module Client.Admin.UserGuides

open Client
open Elmish
open Shared.Admin.UserInfo
open Illy.SafeStack.Client
open Shared
open Illy.SafeStack.Client.jQueryUI
open Fable.React
open Fable.React.Props


type Model =
    {
        Loading: bool
        Guides: Guide list
    }

type Msg =
    | LoadedGuides of Guide list
    | UserGuideClicked of Guide
    | UserGuideDownloaded of unit
    | ApiError of ApiError
    | CloseOverlay

type Event =
    | ApiError of ApiError
    | CloseOverlay

let init() =
    {
        Guides = []
        Loading = true
    }, Api.secureCall<IAdminUserGuidesApi,_,_,_> SecuredRoute.Admin (fun api -> api.listGuides) () LoadedGuides Msg.ApiError

let update msg model =
    match msg with
    | Msg.CloseOverlay -> model, CloseOverlay |> SideEffect.Event
    | Msg.ApiError err -> model, err |> ApiError |> SideEffect.Event
    | LoadedGuides guides ->
        {
            model with
                Guides = guides
                Loading = false
        }, SideEffect.none
    | UserGuideClicked guide ->
        model, Api.downloadFile SecuredRoute.Admin (fun x -> x.downloadGuide) guide.Key UserGuideDownloaded Msg.ApiError |> SideEffect.Cmd
    | UserGuideDownloaded _ ->
        model, SideEffect.none

let skeletonGuide =
    {
        Key = ""
        Name = "User Guide Name"
    }

let skeletonScreenGuides =
    [
        skeletonGuide
        skeletonGuide
        skeletonGuide
    ]

let view model dispatch =
    jQueryUI.modal
        "User Guides"
        2000
        Msg.CloseOverlay
        dispatch
        (Some 600)
        [
            div [ Id "user-guides" ] [
                let guides = if model.Loading then skeletonScreenGuides else model.Guides
                for guide in guides do
                    yield div [ Class "userGuide" ] [
                        yield label [
                            Class (jQueryUI.addSkeletonScreen "" None model.Loading)
                        ] [ str guide.Name ]
                        if not model.Loading then
                            yield a [
                                ClassName "download"
                                OnClick (fun _ -> guide |> UserGuideClicked |> dispatch)
                            ] [
                                FontAwesome.light "file-pdf" [ FontAwesome.Size FontAwesome.X2 ] []
                            ]
                    ]
                ]
        ]